export default __webpack_public_path__ + "static/media/compas_lime_data.0660b10a.csv";